import axios from 'axios';
import Vue from 'vue';

axios.defaults.baseURL = '';

class ApiService {
  setHeaders(data = false, image = false, file = false) {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    if (data) {
      delete headersConfig['Content-Type'];
      delete headersConfig['Accept'];
      headersConfig['Content-Type'] = 'multipart/form-data';
    }

    if (image) {
      headersConfig['Accept'] = 'image/png';
    }

    if (file) {
      headersConfig['Content-Type'] = 'application/pdf';
      headersConfig['Accept'] = 'application/pdf';
    }

    return headersConfig;
  }

  // options: configurações extras do axios (ex.: cancelToken)
  get(url, params, options = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_url}${url}`, { headers: this.setHeaders(), params: params, ...options })
        .then(response => {
          resolve(response.data || response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  post(url, form, params = new URLSearchParams(), isFormData = false) {
    return new Promise((resolve, reject) => {
      axios.post(
        `${Vue.prototype.$config.api_url}${url}`, 
        form, 
        { 
          headers: isFormData ? undefined : this.setHeaders(isFormData),
          params: params 
        })
        .then(response => {
          resolve(response.data || response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  delete(url, params) {
    return new Promise((resolve, reject) => {
      axios.delete(`${Vue.prototype.$config.api_url}${url}`, { headers: this.setHeaders(), params: params })
        .then(response => {
          resolve(response.data || response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  put(url, form, params, isFormData = false) {
    return new Promise((resolve, reject) => {
      axios.put(`${Vue.prototype.$config.api_url}${url}`, form, { headers: this.setHeaders(isFormData), params: params })
        .then(response => {
          resolve(response.data || response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  getWithoutApiUrl(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(url, { headers: null, params: params })
        .then(response => {
          resolve(response.data || response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }


  downloadFile(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_url}${url}`, { headers: { 'responseType': 'blob' }, params: params, responseType: 'arraybuffer' })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log('[downloadFile]', error);
          try {
            const respError = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(error)));
            reject(respError);
          } catch (error) {
            reject(String.fromCharCode.apply(null, new Uint8Array(error)));
          }
        });
    });
  }

  readFile(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_url}${url}`, { headers: this.setHeaders(), params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  downloadPublicFile(url, params) {
    return new Promise((resolve, reject) => {
      axios.get(`${Vue.prototype.$config.api_url}${url}`, { headers: { 'responseType': 'blob' }, params: params, responseType: 'arraybuffer' })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  postDataUrl(url, form, params = new URLSearchParams()) {
    return new Promise((resolve, reject) => {
      axios.post(`${url}`, form, { headers: {}, params: params })
        .then(response => {
          resolve(response.data || response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  getWithBasicAuth(url, auth) {
    return new Promise((resolve, reject) => {
      axios.get(`${url}`, auth)
        .then(response => {
          resolve(response.data || response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

}

export default new ApiService();
